/**
 * GoQuadros (21/10/2026): o lazy nativo antecipa fotos de vários carrosséis fora da tela.
 * Guarda a imagem no template até o card chegar a 300px da tela, para essas fotos não
 * disputarem a conexão com o banner LCP. O card mantém seu tamanho antes da imagem.
 */
class GqDeferredImage extends HTMLElement {
  /** @type {IntersectionObserver | undefined} */
  #observer;

  connectedCallback() {
    if (!this.querySelector('template')) return;
    if (!('IntersectionObserver' in window) || window.Shopify?.designMode) {
      this.#load();
      return;
    }
    this.#observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) this.#load();
    }, { rootMargin: '300px 0px' });
    // O host usa display: contents; a caixa do card é a referência de visibilidade.
    this.#observer.observe(this.parentElement);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #load() {
    const template = this.querySelector('template');
    if (!template) return;
    this.#observer?.disconnect();
    this.replaceChildren(template.content.cloneNode(true));
  }
}

if (!customElements.get('gq-deferred-image')) customElements.define('gq-deferred-image', GqDeferredImage);
